import { AfterViewInit, Component, inject, Signal, viewChild } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AlertDialogsDirective, AlertDialogService, ConfirmActionModalHostDirective, ConfirmActionModalService, ModalDirective, ModalService } from '@work-frontend-monorepo/work-ui/modals';
import { EnvironmentRibbonComponent, LogoComponent } from '@work-frontend-monorepo/work-ui/layout';


@Component({
  imports: [
    RouterModule,
    AlertDialogsDirective,
    ConfirmActionModalHostDirective,
    ModalDirective,
    LogoComponent,
    EnvironmentRibbonComponent,
  ],
  selector: 'work-tablesoccer-root',
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements AfterViewInit {
  private alertDialogsHost: Signal<AlertDialogsDirective | undefined> = viewChild(AlertDialogsDirective);
  private confirmActionModalHost: Signal<ConfirmActionModalHostDirective | undefined> = viewChild(ConfirmActionModalHostDirective);
  private modalHost: Signal<ModalDirective | undefined> = viewChild(ModalDirective);

  private readonly alertDialogService = inject(AlertDialogService);
  private readonly confirmActionModalService = inject(ConfirmActionModalService);
  private readonly modalService = inject(ModalService);

  ngAfterViewInit() {
    const host = this.alertDialogsHost();
    if (host) {
      this.alertDialogService.setAlertDialogsHost(host);
    }
    const confirmHost = this.confirmActionModalHost();
    if (confirmHost) {
      this.confirmActionModalService.setModalHost(confirmHost);
    }
    const modal = this.modalHost();
    if (modal) {
      this.modalService.setModalHost(modal);
    }
  }

  protected reload() {
    window.location.reload();
  }
}
